<template>
    <rkm-layout-body title="Alto custo - Processos">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'farmacia-alto-custo-gerenciamento-processo-index' })"
                color="danger"
            >
                Sair
            </rkm-button>

            <rkm-button
                @click="$router.push({ name: 'farmacia-alto-custo-gerenciamento-processo-create', params: { pacienteId }})"
                authorize="create-farmacia-alto-custo-gerenciamento-processo"
                color="primary"
            >
                <rkm-icon icon="plus" /> Cadastrar processo
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List :paciente-id="pacienteId" />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/farmacia/alto-custo-gerenciamento-processo/components/processo/List'

export default {
    components: { List },
    props: {
        pacienteId: { type: Number, required: true },
    },
}
</script>
